import React, {useState} from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import {ReactComponent as Textph} from "../../assets/svg/illustration-woman-online-mobile.svg"
import {Helmet} from "react-helmet";

const Video = ()=>{
    return(
        <div className='text-wrap'>
            <div className='text-dec'>
                <Helmet>
                    <title>راهنمای ویدیویی بل میت</title>
                    <meta name="description" content="نحوه دریافت سرویس رایگان رویداد آنلاین و وب کنفرانس بل میت" />
                </Helmet>
                <Nav/>
                <main className="card">
                    <div className="hero">
                        <Textph/>
                    </div>
                    <h2 className="title">راهنمای ویدیویی</h2>
                    <div className="acc-container">
                        <h3>راهنمای سایت BellMeet</h3>
                        <TextItem
                            title={'ثبت نام و ورود به بل میت'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/14.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'نحوه دریافت سرویس رایگان'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/9.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'خرید سرویس جدید و تمدید سرویس'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/10.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <h3>راهنمای پنل BellMeet</h3>
                        <TextItem
                            title={'تعریف و مدیریت کاربران'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/11.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'ایجاد و مدیریت اتاق ها و دسترسی کاربران'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/12.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                        title={'خرید پلن'}
                    >
                        <video controls>
                            <source src="https://bellmeet.com/helpvideo/13.mp4" type="video/mp4" />
                            Your browser does not support HTML video.
                        </video>
                    </TextItem>
                        <h3>راهنمای محیط BellMeet</h3>
                        <TextItem
                            title={'آشنایی با محیط اتاق بل میت'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/1.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'راهنمای استفاده شرکت کنندگان یا کاربران'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/2.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'کار با بخش کاربران در اتاق بل میت'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/3.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'کار با بخش پیام ها و اعلانات در اتاق بل میت'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/4.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'بخش تنظیمات اتاق بل میت'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/5.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'اشتراگ گذاری صفحه نمایش در اتاق بل میت'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/6.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'بارگذاری و استفاده از فایل در اتاق بل میت'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/7.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <TextItem
                            title={'کار با تخته یا بورد در اتاق بل میت'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/8.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                    </div>
                </main>
                <Footer/>
            </div>
        </div>
    )
}

const TextItem = ({title,children,defOpen = false}) =>{
    const [isOpen,setIsOpen] = useState(defOpen)
    return(
        <>
            <button onClick={()=>setIsOpen(p=>!p)} className={`acc-btn ${isOpen ? 'active' : ''}`}>{title}</button>
            <div className={`acc-content ${isOpen ? 'active' : ''}`}>
                {children}
            </div>
        </>
    )
}

export default Video